import { type Coordinates } from '@/features/place/types/place-types';

export default function calculateEarthRadius(latitude: Coordinates['latitude']) {
  //  get the radius of the earth at this latitude
  const majorAxisWGS84 = 6378137; // the equatorial radius of WGS84 ellipsoid (6378137 m). major axis
  const minorAxisWGS84 = 6356752.3; // minor axis
  const An = majorAxisWGS84 * majorAxisWGS84 * Math.cos(latitude);
  const Bn = minorAxisWGS84 * minorAxisWGS84 * Math.sin(latitude);
  const Ad = majorAxisWGS84 * Math.cos(latitude);
  const Bd = minorAxisWGS84 * Math.sin(latitude);

  return Math.sqrt((An * An + Bn * Bn) / (Ad * Ad + Bd * Bd));
}
